/**
 * Returns selected yaml Graphql node data
 * @param {any} data The Graphql query
 * @param {String} path The intended target path for the node data
 * @returns {Object} The returned useful yaml Graphql data
 */
export const getYamlNodeData = (data, tag, id = "") => {
  if (!data) return {}

  const { allContent } = data
  if (!allContent) return {}

  const { edges } = allContent
  if (!edges) return {}
  if (edges.length <= 0) return {}

  const { node } = id
    ? edges.find(e => e.node && e.node[tag].id === id)
    : edges[0]
  if (!node) return {}

  return node
}

export const getYamlImage = (data, imageName = "") => {
  if (!data) return {}

  const { allImageSharp } = data
  if (!allImageSharp) return {}

  const { edges } = allImageSharp
  if (!edges) return {}
  if (edges.length <= 0) return {}

  const { node } = imageName
    ? edges.find(
        e =>
          e.node &&
          e.node.gatsbyImageData.images.fallback.src.indexOf(imageName) !== -1
      )
    : edges[0]
  if (!node) return {}

  return node
}

export const getYamlCaseStudyData = (data, tag, slug = "") => {
  if (!data) return {}

  const { allContent } = data
  if (!allContent) return {}

  const { edges } = allContent
  if (!edges) return {}
  if (edges.length <= 0) return {}

  const { node } = slug
    ? edges.find(e => e.node && e.node[tag] && e.node[tag].slug === slug)
    : edges[0]
  if (!node) return {}

  return node
}

export const getMarkdownCurrentOpenPosition = (data, slug = "") => {
  if (!data) return {}

  const { allMarkdownRemark } = data
  if (!allMarkdownRemark) return {}

  const { edges } = allMarkdownRemark
  if (!edges) return {}
  if (edges.length <= 0) return {}

  const { node } = slug
    ? edges.find(
        e => e.node && e.node.frontmatter && e.node.frontmatter.slug === slug
      )
    : edges[0]
  if (!node) return {}

  return node
}
